// extracted by mini-css-extract-plugin
module.exports = {"w1bg1u8e":"w1bg1u8e","pizm2rb":"pizm2rb"};